import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";
import { API_URL_FELL } from "../../../config";
import { CalculateBitrateData, QuickStartResponse, PostQuickStartPayload, QuickStartProject } from "lib/types"

export const getCalculateBitrateThunk = createAsyncThunk<
    number,
    { calculateBitrateData: CalculateBitrateData },
    { rejectValue: string }
>(
    "tools/getCalculateBitrate",
    async ({ calculateBitrateData }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${API_URL_FELL()}/tools/calculatebitrate`, {
                params: calculateBitrateData
            });
            return response.data;
        } catch (err) {
            let error: AxiosError<string> = err;
            return rejectWithValue(error.response?.data);
        }
    }
);

export const getQuickStartThunk = createAsyncThunk<
    QuickStartResponse,
    void,
    { rejectValue: string }
>(
    "tools/getQuickStart",
    async (_: void, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${API_URL_FELL()}/tools/quickstart`);
            const data = response.data as QuickStartResponse;

            //JavaScript automatically sorts numeric-like keys in ascending order inside plain objects no matter how you insert them.
            //so We convert the projects object into a sorted array here for easier usage in the UI.
            if (data?.projects) {
                const sortedProjects = Object.values(data.projects)
                    .sort((a: QuickStartProject, b: QuickStartProject) => b.id - a.id);

                data.sortedProjects = sortedProjects;                
            }

            return data;
        } catch (err) {
            const error: AxiosError<string> = err as AxiosError<string>;
            return rejectWithValue(error.response?.data || "Failed to fetch quick start data");
        }
    }
);

export const postQuickStartThunk = createAsyncThunk<
    any,
    { payload: PostQuickStartPayload },
    { rejectValue: string }
>(
    "tools/postQuickStart",
    async ({ payload }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${API_URL_FELL()}/tools/quickstart`, payload);
            return response.data;
        } catch (err) {
            const error: AxiosError<string> = err as AxiosError<string>;
            return rejectWithValue(error.response?.data || "Failed to submit quick start data");
        }
    }
);
